import {
    Button, HStack, Text, VStack,
} from '@chakra-ui/react';
import { AccessIssuesWizardMachineContext } from '../machine/context';
import { AccessIssuesWizardSolutionProps } from '../types';

function AccessIssuesWizardDebugBar({
    solution,
    entryMethod,
}: AccessIssuesWizardSolutionProps) {
    const machine = AccessIssuesWizardMachineContext.useActorRef();
    const isDebugMode = AccessIssuesWizardMachineContext.useSelector(
        (state) => state.context.enableDebugMode
    );

    if (!isDebugMode) return null;

    return (
        <VStack mb={4}>
            <HStack bgColor="charcoal.25" w="100%" py={3} px={3} rounded="md">
                <Text fontSize="sm" flexGrow={1}>
                    Debug Mode
                    {' / '}
                    {solution.solution_label}
                    {' / '}
                    {entryMethod}
                </Text>
                <Button
                    onClick={() => machine.send({
                        type: 'FAKE_MARK_AS_AGENCY_ACTION',
                        solutionLabel: solution.solution_label,
                    })}
                    size="sm"
                    colorScheme="charcoal"
                >
                    Resolve (fake)
                </Button>
                <Button
                    onClick={() => machine.send({
                        type: 'DISABLE_DEBUG_MODE',
                    })}
                    size="sm"
                    colorScheme="charcoal"
                >
                    Disable Debug
                </Button>
            </HStack>
        </VStack>
    );
}

export { AccessIssuesWizardDebugBar };
